import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Apps, FileManager } from "../../../Constants/Constants";
import FileSideBar from "./FileSideBar/FileSideBar";
import FileContent from "./FileContent/FileContent";
import { Fragment } from "react/jsx-runtime";

const FileManagerContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={FileManager} parent={Apps} />
      <Container fluid>
        <Row>
          <FileSideBar />
          <Col xl="9" md="12" className="box-col-12">
            <div className="file-content">
              <FileContent />
            </div>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default FileManagerContainer;
